// extracted by mini-css-extract-plugin
module.exports = {"assigner":"ProjectAssigner_assigner__O7kjt","popover":"ProjectAssigner_popover__3lprZ"};